module.exports = [
    { name: "Item", view: "card" },
    { name: "Stock", view: "table" },
    { name: "Vendor", view: "table" },
    { name: "Market", view: "table" },
];
